// extracted by mini-css-extract-plugin
export default {"productCardsWrapper":"cardsGrid_productCardsWrapper__98U0g","showMore":"cardsGrid_showMore__YnK3u","productNoCardsWrapper":"cardsGrid_productNoCardsWrapper__UWmhl"};